import React from 'react';

type TabContentProps = {
  selectedTab: string;
  tab: string;
  children?: React.ReactNode;
};

export const TabContent: React.FC<TabContentProps> = ({
  selectedTab,
  tab,
  children
}) => {
  if (selectedTab === tab) {
    return <>{children}</>;
  }

  return null;
};
